<template>
  <div v-if="session" class="overflow-y-auto d-flex flex-column" style="height: calc(100dvh - 152px);">
    <div :class="{ 'sticky': !showSwapConfirmationModal }" class="top-0 white-bg z1">
      <div class="d-flex align-center">
        <v-col cols="6">
          <v-col cols="12" :class="[{'disable':!!session.cancelled},'d-flex justify-space-between align-center']">
            <div
              class="d-flex align-center"
            >
              {{ authUser.firstname }} {{ authUser.lastname }}
            </div>
          </v-col>
        </v-col>
        <v-col cols="6">
          <v-col cols="12" :class="[{'disable':!!session.cancelled},'d-flex justify-center align-center']">
            <div
              v-if="instructorHorse"
              class="d-flex align-center"
            >
              {{ getHorseName(instructorHorse) }}
              <v-btn v-if="canUserPerformAction" icon @click="removeHorse(null)">
                <v-icon>mdi-minus-circle-outline</v-icon>
              </v-btn>
            </div>
            <v-btn v-else-if="canUserPerformAction" icon @click="openAddHorseModal('instructor')">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-col>
      </div>
      <hr style="border: 1px solid black">
    </div>
    <div
      v-for="(participantHorse, index) in participantsHorse"
      :key="`session_participant_${index}`"
    >
      <div class="d-flex align-center">
        <v-col
          cols="6"
        >
          <v-col cols="12" :class="[{'disable':!!session.cancelled},'d-flex justify-space-between align-center']">
            <div v-if="participantHorse.participant" :class="[{'lightBlue-bg':isContentSelect(participantHorse.participant.uuid)},'d-flex align-center']" @click="performSelectAction(participantHorse, 'participant')">
              {{ getParticipantName(participantHorse.participant) }}
              <v-btn v-if="canUserPerformAction" icon @click="removeParticipant(participantHorse.participant)">
                <v-icon>mdi-minus-circle-outline</v-icon>
              </v-btn>
            </div>
            <v-btn v-else-if="canUserPerformAction" icon class="pointer" @click="openAddParticipantModal(participantHorse)">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <span v-else>N/A</span>
          </v-col>
        </v-col>
        <v-col
          cols="6"
        >
          <v-col cols="12" :class="[{'disable':!!session.cancelled},'d-flex justify-center align-center']">
            <div
              class="d-flex align-center"
            >
              <div v-if="participantHorse.horse" class="mb-0">
                <span :class="[{'lightBlue-bg':isContentSelect(participantHorse.horse.uuid)}]" @click="performSelectAction(participantHorse, 'horse')">
                  {{ participantHorse.horse.horse_name }}
                </span>
                <v-btn v-if="canUserPerformAction" icon @click="removeHorse(participantHorse)">
                  <v-icon>mdi-minus-circle-outline</v-icon>
                </v-btn>
              </div>
              <v-btn v-else-if="canUserPerformAction" icon class="pointer" :disabled="!canAddHorse(participantHorse.participant)" @click="openAddHorseModal(participantHorse.participant)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <span v-else>N/A</span>
            </div>
          </v-col>
        </v-col>
      </div>
      <v-divider />
    </div>
    <div class="full-width text-center full-height align-content-end">
      <v-btn
        color="third"
        outlined
        small
        rounded
        class="font-weight-bold my-4"
        @click="openAddHorseModal(null)"
      >
        Ajouter un cheval
        <v-icon size="24" color="third" right>mdi-plus</v-icon>
      </v-btn>
    </div>

    <AddHorseModal />
    <AddParticipantModalMobile />
    <SelectParticipantModal v-if="showParticipantModal" />

    <ConfirmationModal
      v-if="showSwapConfirmationModal"
      title="Confirmation"
      :width="null"
      :activator.sync="showSwapConfirmationModal"
      :close-modal="changeConfirmationModal"
      :action="swapContent"
      btn-label="échanger"
      btn-icon="mdi-swap-horizontal"
    >
      <template #body>
        <h3 class="black--text">
          Voulez-vous échanger {{ contentLabel }} {{ selectedContent.displayName }} avec {{ contentLabel }} {{ contentToSwap.displayName }}?
        </h3>
      </template>
    </ConfirmationModal>

    <MaxEffortConfirmation />
  </div>
</template>

<script>
import { computed, ref, provide, inject } from '@vue/composition-api';

import { sendNotification } from '@/helpers/utils';
import { updateSessionAmplify } from '@/helpers/amplify';
import AddHorseModal from '../AddHorseModal.vue';
import AddParticipantModalMobile from '../AddParticipantModalMobile.vue';
import ConfirmationModal from '@/components/common//ConfirmationModal.vue';
import SelectParticipantModal from '@/components/ParticipantHorse//SelectParticipantModal.vue';
import MaxEffortConfirmation from '@/components/horse/MaxEffortConfirmation.vue';
import { presenseStatus } from '@/helpers/variables';
import { checkHorseDailyEffort } from '@/helpers/dataManager';

import store from '@/store';

export default {
  components: { AddHorseModal, AddParticipantModalMobile, ConfirmationModal, SelectParticipantModal, MaxEffortConfirmation },
  setup () {
    const session = inject('selectedSession');
    const updateSession = inject('updateSession');
    const showSwapConfirmationModal = ref(false);
    const addHorseDialog = ref(false);
    const selectedContent = ref(null);
    const contentToSwap = ref(null);
    const selectedParticipant = ref(null);
    const showParticipantModal = ref(false);
    const selectParticipantModalData = ref(null);
    const selectedCustomer = ref(null);
    const selectedHorse = ref(null);

    const addParticipantDialog = inject('addParticipantDialog');

    const authUser = computed(() => store.state.user);
    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    const participantsHorse = computed(() => {
      const participantsHorseArray = [];

      (session.value.participants || []).map(participant => {
        participantsHorseArray.push({
          horse: participant.horse ? store.getters.horse(participant.horse) : null,
          participant: participant
        });
      });

      (session.value.horses || []).map(horse => {
        const isHorseAlreadyAdded = participantsHorseArray.some(p => p.horse && p.horse.uuid === horse.uuid);

        const horseInUseByInstructor = (session.value.instructors || []).some(instructor => instructor.horse === horse.uuid);

        if (!isHorseAlreadyAdded && !horseInUseByInstructor) {
          participantsHorseArray.push({
            horse: store.getters.horse(horse.uuid),
            participant: null
          });
        }
      });

      return participantsHorseArray;
    });

    const sessionInstructorIndex = computed(() => (session.value.instructors || []).findIndex(i => i.uuid === authUser.value.uuid));

    const instructorHorse = computed(() => {
      const instructor = session.value.instructors.find(i => i.uuid === authUser.value.uuid);
      return instructor && !!instructor.horse ? instructor.horse : null;
    });

    const contentLabel = computed(() => (selectedContent.value && selectedContent.value.wtype === 'horse' ? 'cheval' : 'participant'));

    const removeHorse = participantHorse => {
      if (!participantHorse) {
        const instructorHorseIndex = session.value.horses.findIndex(horse => horse.uuid === instructorHorse.value);
        if (instructorHorseIndex !== -1) {
          session.value.horses.splice(instructorHorseIndex, 1);
        }
        session.value.instructors[sessionInstructorIndex.value].horse = null;

        updateSession();
        return;
      }
      if (!participantHorse.participant) {
        const horseIndex = session.value.horses.findIndex(h => h.uuid === participantHorse.horse.uuid);
        session.value.horses.splice(horseIndex, 1);
        updateSession();
        return;
      }

      const sessionParticipantIndex = session.value.participants.findIndex(p => p.uuid === participantHorse.participant.uuid);

      const horse_uuid = session.value.participants[sessionParticipantIndex].horse;

      const horseIndex = session.value.horses.findIndex(h => h.uuid === horse_uuid);

      session.value.horses.splice(horseIndex, 1);

      session.value.participants[sessionParticipantIndex].horse = null;

      updateSession();
    };

    const getParticipantName = participant => `${participant.firstname} ${participant.lastname}`;

    const getHorseName = horse_uuid => {
      const horseDetail = store.getters.horse(horse_uuid);

      return horseDetail ? horseDetail.horse_name : 'NO_NAME';
    };

    const openAddHorseModal = participant => {
      selectedParticipant.value = participant;
      selectedHorse.value = null;
      addHorseDialog.value = true;
    };

    const addHorseToParticipant = async (effortCallback = false) => {
      const isHorseOnSessionIndex = (session.value.horses || []).findIndex(h => h.uuid === selectedHorse.value.uuid);

      if (isHorseOnSessionIndex !== -1) {
        session.value.horses.splice(isHorseOnSessionIndex, 1);

        const participantIndex = (session.value.participants || []).findIndex(p => p.horse === selectedHorse.value.uuid);
        if (participantIndex !== -1) {
          session.value.participants[participantIndex].horse = null;
        }
      } else if (!effortCallback && isHorseOnSessionIndex === -1) {
        const checkForHorseEffort = await checkHorseDailyEffort([selectedHorse.value], [session.value]);
        if (Object.keys(checkForHorseEffort).length) {
          store.commit('setAlertEffort', checkForHorseEffort);
          store.commit('setShowMaxEffortModal', true);
          store.commit('setMaxEffortCallback', () => {
            addHorseToParticipant(true);
          });
          return;
        }
      }

      const isInstructor = selectedParticipant.value === 'instructor';

      session.value.horses.push({
        uuid: selectedHorse.value.uuid,
        wtitle: selectedHorse.value.horse_name,
        isInstructorHorse: !!isInstructor
      });

      if (selectedParticipant.value && !isInstructor) {
        const sessionParticipantIndex = session.value.participants.findIndex(p => p.uuid === selectedParticipant.value.uuid);
        session.value.participants[sessionParticipantIndex].horse = selectedHorse.value.uuid;
      }

      if (isInstructor) {
        session.value.instructors[sessionInstructorIndex.value].horse = selectedHorse.value.uuid;
      }

      updateSession();
    };

    const openAddParticipantModal = participantHorse => {
      selectParticipantModalData.value = { participantHorse: { horse: participantHorse.horse.uuid } };
      addParticipantDialog.value = true;
    };

    const isContentSelect = uuid => selectedContent.value && selectedContent.value.uuid === uuid;

    const computedSelectedValue = (participantHorse, wtype) => ({
      ...participantHorse,
      uuid: participantHorse[wtype].uuid,
      displayName: wtype === 'horse' ? participantHorse.horse.horse_name : `${participantHorse.participant.firstname} ${participantHorse.participant.lastname}`,
      wtype
    });

    const performSelectAction = (participantHorse, wtype) => {
      if (!selectedContent.value) {
        selectedContent.value = computedSelectedValue(participantHorse, wtype);
        return;
      }

      if (wtype !== selectedContent.value.wtype) {
        sendNotification('error', 'Impossible de glisser-déposer pour un type différent');
        return;
      }

      if (selectedContent.value.uuid === participantHorse[wtype].uuid) {
        selectedContent.value = null;
        // sendNotification('error', `veuillez en sélectionner un autre ${contentLabel.value}`);
        return;
      }

      contentToSwap.value = computedSelectedValue(participantHorse, wtype);
      showSwapConfirmationModal.value = true;
    };

    const changeConfirmationModal = () => {
      showSwapConfirmationModal.value = !showSwapConfirmationModal.value;
      selectedContent.value = null;
      contentToSwap.value = null;
    };

    const swapContent = () => {
      let sessionHaveChanges = false;

      // if both horses have participants
      if (selectedContent.value.participant && contentToSwap.value.participant) {
        const firstParticipantIndex = session.value.participants.findIndex(p => p.uuid === selectedContent.value.participant.uuid);
        const secondParticipantIndex = session.value.participants.findIndex(p => p.uuid === contentToSwap.value.participant.uuid);

        if (firstParticipantIndex !== -1 && secondParticipantIndex !== -1) {
          const auxiliar = session.value.participants[firstParticipantIndex].horse;
          session.value.participants[firstParticipantIndex].horse = session.value.participants[secondParticipantIndex].horse;
          session.value.participants[secondParticipantIndex].horse = auxiliar;
          sessionHaveChanges = true;
        }
      }

      // if only one have participant
      if (selectedContent.value.participant || contentToSwap.value.participant) {
        const participant = selectedContent.value.participant || contentToSwap.value.participant;

        const participantIndex = session.value.participants.findIndex(p => p.uuid === participant.uuid);

        if (participantIndex !== -1) {
          session.value.participants[participantIndex].horse = selectedContent.value.participant ? contentToSwap.value.horse.uuid : selectedContent.value.horse.uuid;

          sessionHaveChanges = true;
        }
      }

      if (sessionHaveChanges) {
        updateSession();
      }

      changeConfirmationModal();
      selectedContent.value = null;
      contentToSwap.value = null;
    };

    const removeParticipant = async participant => {
      const participantIndex = session.value.participants.findIndex(p => p.uuid === participant.uuid);

      if (participantIndex !== -1) {
        const sessionToUpdate = { ...session.value };
        sessionToUpdate.participants.splice(participantIndex, 1);

        await updateSessionAmplify({ id: session.value.id, participants: sessionToUpdate.participants });
      }
    };

    const canAddHorse = participant => !participant || participant.presence_status !== presenseStatus.ABSENT;

    provide('addHorseDialog', addHorseDialog);
    provide('selectedHorse', selectedHorse);
    provide('selectedHorse', selectedHorse);
    provide('showSwapConfirmationModal', showSwapConfirmationModal);
    provide('addHorseToParticipant', addHorseToParticipant);
    provide('showParticipantModal', showParticipantModal);
    provide('selectParticipantModalData', selectParticipantModalData);
    provide('selectedParticipant', selectedCustomer);

    return { canUserPerformAction, canAddHorse, removeParticipant, showParticipantModal, contentLabel, selectedContent, contentToSwap, swapContent, changeConfirmationModal, showSwapConfirmationModal, isContentSelect, performSelectAction, openAddParticipantModal, participantsHorse, authUser, session, getParticipantName, getHorseName, instructorHorse, removeHorse, openAddHorseModal };
  }
};
</script>
